export const getXCSRFToken = () =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]').content;
